goog.provide("shadow.js.shim.module$src$svg$controls$hand_draw_svg");
goog.provide("module$shadow_js_shim_module$src$svg$controls$hand_draw_svg");
shadow.js.shim.module$src$svg$controls$hand_draw_svg = shadow.js.nativeProvides["src/svg/controls/hand-draw.svg"] = shadow$bridge("src/svg/controls/hand-draw.svg");
module$shadow_js_shim_module$src$svg$controls$hand_draw_svg.default = shadow.js.shim.module$src$svg$controls$hand_draw_svg;
